import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VerificacaoSegurancaComponent } from './verificacao-seguranca.component';

const routes: Routes = [
  {
    path: '',
    component: VerificacaoSegurancaComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificacaoSegurancaRoutingModule { }
